module.exports = __webpack_public_path__ + "assets/alerts_link_charts.png";